import { render, staticRenderFns } from "./PreventiveList.vue?vue&type=template&id=9bcb7c4c&scoped=true"
import script from "./PreventiveList.vue?vue&type=script&lang=js"
export * from "./PreventiveList.vue?vue&type=script&lang=js"
import style0 from "./PreventiveList.vue?vue&type=style&index=0&id=9bcb7c4c&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "9bcb7c4c",
  null
  
)

export default component.exports